import { createReactModel } from '@rst/libs-ts'
import { createEvent, restore } from 'effector'

const createZIndexModel = () => {
	const setZIndex = createEvent<number>()
	const $zIndex = restore(setZIndex, 1201)

	return { $zIndex, setZIndex }
}

export const { Wrapper: ProviderModel, useCtx: useModelCtx } = createReactModel<
	ReturnType<typeof createZIndexModel>,
	any
>(() => createZIndexModel())
